import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useTranslation } from 'react-i18next';

interface AISearchButtonProps {
  onClick: () => void;
}

const AISearchButton: React.FC<AISearchButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Tooltip arrow title={t('search.aiSearch')}>
      <IconButton color="primary" onClick={onClick}>
        <AutoAwesomeIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default AISearchButton;
